// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sashe-settings-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.settings-header {
  text-align: center;
  margin-bottom: 40px;
}

.settings-header h1 {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.header-icon {
  color: #3b82f6;
  font-size: 2rem;
}

.settings-description {
  color: #666;
  font-size: 1.1rem;
}

.credentials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
}

.credential-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.credential-card:hover {
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.credential-card.inactive {
  opacity: 0.7;
}

.card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
}

.shop-icon {
  font-size: 2rem;
}

.card-header h2 {
  flex: 1 1;
  margin: 0;
  font-size: 1.5rem;
}

.status-badge {
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
}

.status-badge.active {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.status-badge.inactive {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.card-body {
  padding: 25px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  color: #555;
  font-weight: 600;
  font-size: 0.95rem;
}

.field-icon {
  color: #8b5cf6;
  font-size: 1rem;
}

.form-input {
  width: 100%;
  padding: 10px 15px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-input:focus {
  outline: none;
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
}

.password-input-group {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-group .form-input {
  padding-right: 45px;
}

.password-toggle {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 5px;
  font-size: 1.2rem;
  transition: color 0.3s ease;
}

.password-toggle:hover {
  color: #8b5cf6;
}

.checkbox-group {
  margin: 25px 0;
}

.checkbox-group label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.checkbox-group input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #8b5cf6;
}

.checkbox-group span {
  font-size: 1rem;
  color: #333;
}

.last-updated {
  font-size: 0.85rem;
  color: #9ca3af;
  margin-bottom: 20px;
  padding: 10px;
  background: #f9fafb;
  border-radius: 6px;
}

.save-button {
  width: 100%;
  padding: 12px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s ease;
}

.save-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.save-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.button-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.info-box {
  background: #f0f9ff;
  border: 2px solid #3b82f6;
  border-radius: 12px;
  padding: 25px;
  margin-top: 40px;
}

.info-box h3 {
  margin: 0 0 15px 0;
  color: #1e40af;
  font-size: 1.3rem;
}

.info-box ul {
  margin: 0;
  padding-left: 25px;
}

.info-box li {
  margin-bottom: 10px;
  color: #374151;
  line-height: 1.6;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 20px;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(139, 92, 246, 0.2);
  border-top-color: #8b5cf6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .credentials-grid {
    grid-template-columns: 1fr;
  }

  .settings-header h1 {
    font-size: 2rem;
  }
}

/* ============ DARK THEME OVERRIDES ============ */
[data-theme="dark"] .settings-header h1 {
  color: var(--text-primary);
}

[data-theme="dark"] .settings-description {
  color: rgba(226, 232, 240, 0.75);
}

[data-theme="dark"] .credential-card {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

[data-theme="dark"] .credential-card:hover {
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.5);
  border-color: rgba(255, 255, 255, 0.15);
}

[data-theme="dark"] .form-group label {
  color: rgba(226, 232, 240, 0.9);
}

[data-theme="dark"] .form-input {
  background: rgba(15, 23, 42, 0.6);
  color: var(--text-primary);
  border: 2px solid rgba(255, 255, 255, 0.15);
}

[data-theme="dark"] .form-input:focus {
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.2);
}

[data-theme="dark"] .password-toggle {
  color: rgba(226, 232, 240, 0.6);
}

[data-theme="dark"] .password-toggle:hover {
  color: #a78bfa;
}

[data-theme="dark"] .checkbox-group span {
  color: var(--text-primary);
}

[data-theme="dark"] .last-updated {
  color: rgba(226, 232, 240, 0.6);
  background: rgba(15, 23, 42, 0.4);
}

[data-theme="dark"] .info-box {
  background: rgba(59, 130, 246, 0.1);
  border: 2px solid rgba(59, 130, 246, 0.3);
}

[data-theme="dark"] .info-box h3 {
  color: #93c5fd;
}

[data-theme="dark"] .info-box li {
  color: rgba(226, 232, 240, 0.85);
}

[data-theme="dark"] .spinner {
  border: 4px solid rgba(167, 139, 250, 0.2);
  border-top-color: #a78bfa;
}`, "",{"version":3,"sources":["webpack://./src/features/sashe/SasheSettings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mDAAmD;AACnD;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B","sourcesContent":[".sashe-settings-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.settings-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.settings-header h1 {\n  font-size: 2.5rem;\n  color: #333;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n}\n\n.header-icon {\n  color: #3b82f6;\n  font-size: 2rem;\n}\n\n.settings-description {\n  color: #666;\n  font-size: 1.1rem;\n}\n\n.credentials-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 30px;\n  margin-bottom: 40px;\n}\n\n.credential-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.credential-card:hover {\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);\n  transform: translateY(-2px);\n}\n\n.credential-card.inactive {\n  opacity: 0.7;\n}\n\n.card-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.shop-icon {\n  font-size: 2rem;\n}\n\n.card-header h2 {\n  flex: 1;\n  margin: 0;\n  font-size: 1.5rem;\n}\n\n.status-badge {\n  padding: 5px 15px;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.status-badge.active {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.status-badge.inactive {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.card-body {\n  padding: 25px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  color: #555;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.field-icon {\n  color: #8b5cf6;\n  font-size: 1rem;\n}\n\n.form-input {\n  width: 100%;\n  padding: 10px 15px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #8b5cf6;\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);\n}\n\n.password-input-group {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-group .form-input {\n  padding-right: 45px;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 10px;\n  background: none;\n  border: none;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 5px;\n  font-size: 1.2rem;\n  transition: color 0.3s ease;\n}\n\n.password-toggle:hover {\n  color: #8b5cf6;\n}\n\n.checkbox-group {\n  margin: 25px 0;\n}\n\n.checkbox-group label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: #8b5cf6;\n}\n\n.checkbox-group span {\n  font-size: 1rem;\n  color: #333;\n}\n\n.last-updated {\n  font-size: 0.85rem;\n  color: #9ca3af;\n  margin-bottom: 20px;\n  padding: 10px;\n  background: #f9fafb;\n  border-radius: 6px;\n}\n\n.save-button {\n  width: 100%;\n  padding: 12px 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  transition: all 0.3s ease;\n}\n\n.save-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);\n}\n\n.save-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.button-spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n.info-box {\n  background: #f0f9ff;\n  border: 2px solid #3b82f6;\n  border-radius: 12px;\n  padding: 25px;\n  margin-top: 40px;\n}\n\n.info-box h3 {\n  margin: 0 0 15px 0;\n  color: #1e40af;\n  font-size: 1.3rem;\n}\n\n.info-box ul {\n  margin: 0;\n  padding-left: 25px;\n}\n\n.info-box li {\n  margin-bottom: 10px;\n  color: #374151;\n  line-height: 1.6;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 20px;\n}\n\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(139, 92, 246, 0.2);\n  border-top-color: #8b5cf6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .credentials-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .settings-header h1 {\n    font-size: 2rem;\n  }\n}\n\n/* ============ DARK THEME OVERRIDES ============ */\n[data-theme=\"dark\"] .settings-header h1 {\n  color: var(--text-primary);\n}\n\n[data-theme=\"dark\"] .settings-description {\n  color: rgba(226, 232, 240, 0.75);\n}\n\n[data-theme=\"dark\"] .credential-card {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n[data-theme=\"dark\"] .credential-card:hover {\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.5);\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\n[data-theme=\"dark\"] .form-group label {\n  color: rgba(226, 232, 240, 0.9);\n}\n\n[data-theme=\"dark\"] .form-input {\n  background: rgba(15, 23, 42, 0.6);\n  color: var(--text-primary);\n  border: 2px solid rgba(255, 255, 255, 0.15);\n}\n\n[data-theme=\"dark\"] .form-input:focus {\n  border-color: #a78bfa;\n  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.2);\n}\n\n[data-theme=\"dark\"] .password-toggle {\n  color: rgba(226, 232, 240, 0.6);\n}\n\n[data-theme=\"dark\"] .password-toggle:hover {\n  color: #a78bfa;\n}\n\n[data-theme=\"dark\"] .checkbox-group span {\n  color: var(--text-primary);\n}\n\n[data-theme=\"dark\"] .last-updated {\n  color: rgba(226, 232, 240, 0.6);\n  background: rgba(15, 23, 42, 0.4);\n}\n\n[data-theme=\"dark\"] .info-box {\n  background: rgba(59, 130, 246, 0.1);\n  border: 2px solid rgba(59, 130, 246, 0.3);\n}\n\n[data-theme=\"dark\"] .info-box h3 {\n  color: #93c5fd;\n}\n\n[data-theme=\"dark\"] .info-box li {\n  color: rgba(226, 232, 240, 0.85);\n}\n\n[data-theme=\"dark\"] .spinner {\n  border: 4px solid rgba(167, 139, 250, 0.2);\n  border-top-color: #a78bfa;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
